export const MIN_ENTITY_ID = 1;
export const MIN_SUBMITTED_TICKETS_COUNT = 0;
